"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _tokensStylex = require("web/shared/tokens.stylex.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * The metric list's own devices: a sortable header, and a row that links.
 */
const styles = exports.styles = {
  sortableHeader: {
    cursor: "x1ypdohk",
    userSelect: "x87ps6o",
    ":hover_color": "x1nk9jh9",
    $$css: true
  },
  sortMarker: {
    color: "x19p3n1p",
    $$css: true
  },
  metricLink: {
    textDecoration: "x1hl2dhg",
    textDecorationColor: null,
    textDecorationLine: null,
    textDecorationStyle: null,
    textDecorationThickness: null,
    color: "x1heor9g",
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    ":hover_color": "x1qfsr1m",
    $$css: true
  },
  metricMeaning: {
    display: "x1lliihq",
    color: "xcdm7ny",
    fontFamily: "x1wl88yq",
    fontSize: "x9bimuu",
    paddingTop: "x1iul6r4",
    maxWidth: "xe0576n",
    $$css: true
  }
};